// @ts-check
// Textos da página do portal que conecta o WhatsApp pela Meta (contrato 08 de leads e WhatsApp, seção 8.1). A página
// é servida pelo Worker fora da SPA; os textos ficam em chaves por idioma (só pt-BR por enquanto), como os do formulário
// de captação.

export const META_SIGNUP_MESSAGES = Object.freeze({
  'pt-BR': Object.freeze({
    pageTitle: 'Conectar o WhatsApp',
    loading: 'Preparando a conexão...',
    passInvalid: 'Este link de conexão venceu ou já foi usado. Feche esta janela e clique de novo em Conectar com a Meta, em Configurações > Canais.',
    notConfigured: 'A conexão pela Meta depende da configuração da plataforma e ainda não foi ativada.',
    readyTitle: 'Conectar o WhatsApp de {institution}',
    schoolAddress: 'Pedido em {host}',
    confirmingSchool: 'Confirmando com a janela da escola...',
    openFromSchool: 'Esta janela precisa ser aberta pelo botão Conectar com a Meta, em Configurações > Canais da escola, com a tela de Canais aberta. Por segurança, o link sozinho não conecta nenhum número.',
    question: 'Qual número a escola vai usar?',
    newNumberTitle: 'Um número que não está no app WhatsApp Business',
    newNumberText: 'Pode ser um número novo. A Meta confirma o número por SMS ou ligação. Se ele estiver no aplicativo WhatsApp comum, a conta do aplicativo precisa ser apagada antes.',
    businessAppTitle: 'O número que a escola já usa no app WhatsApp Business',
    businessAppText: 'O número continua funcionando no celular e as conversas aparecem também no Matrícula Mais. Precisa do app WhatsApp Business atualizado (versão 2.24.17 ou mais nova) e do celular por perto para ler um QR code.',
    login: 'Entrar com a Meta',
    loadingSdk: 'Carregando o login da Meta...',
    waiting: 'Siga os passos na janela da Meta. Esta janela continua aberta enquanto isso.',
    connecting: 'Conectando o número à escola...',
    successTitle: 'Pronto!',
    success: 'O número {number} está conectado a {institution}.',
    billing: 'Para enviar mensagens de modelo, a escola precisa cadastrar uma forma de pagamento no WhatsApp Manager da Meta.',
    billingLink: 'Abrir o WhatsApp Manager',
    closingSoon: 'Esta janela fecha sozinha.',
    closeManually: 'Pode fechar esta janela e voltar para o Matrícula Mais.',
    warningRegistration: 'O número foi conectado, mas a Meta não confirmou o registro. Em Configurações > Canais, use Registrar de novo.',
    warningAppData: 'O número foi conectado, mas a Meta não liberou o histórico e os contatos do aplicativo. As mensagens novas chegam normalmente.',
    cancelledAtStep: 'A conexão foi cancelada na etapa {step}. Nada foi alterado.',
    cancelled: 'A conexão foi cancelada antes de terminar. Nada foi alterado.',
    metaError: 'A Meta informou um erro: {message} (código {code}).',
    metaErrorWithoutCode: 'A Meta informou um erro: {message}.',
    retry: 'Tentar de novo',
    retrying: 'Preparando uma nova tentativa...',
    retryWithoutOpener: 'Feche esta janela e clique de novo em Conectar com a Meta, em Configurações > Canais.',
    close: 'Fechar',
    sdkFailed: 'Não foi possível carregar o login da Meta. Confira se algum bloqueador de anúncios ou de rastreamento está ativo e tente de novo.',
    genericError: 'Não foi possível conectar agora. Tente de novo em alguns minutos.',
    poweredBy: 'Conexão segura do Matrícula Mais com a Meta',
  }),
});

// nomes das etapas que a Meta informa ao cancelar (current_step)
export const META_SIGNUP_STEP_MESSAGES = Object.freeze({
  'pt-BR': Object.freeze({
    BUSINESS_ACCOUNT_SELECTION: 'escolha do portfólio da empresa',
    WABA_PHONE_PROFILE_PICKER: 'escolha da conta e do número',
    WHATSAPP_BUSINESS_PROFILE_SETUP: 'perfil do WhatsApp Business',
    PHONE_NUMBER_SETUP: 'cadastro do número',
    PHONE_NUMBER_VERIFICATION: 'confirmação do número',
    PERMISSIONS: 'permissões',
  }),
});

// um texto por código de erro das rotas do portal
export const META_SIGNUP_ERROR_MESSAGES = Object.freeze({
  'pt-BR': Object.freeze({
    META_SIGNUP_CODE_INVALID: 'A confirmação do login com a Meta demorou demais ou foi recusada. Tente de novo.',
    META_SIGNUP_NO_PHONE_NUMBER: 'A conta do WhatsApp Business foi criada, mas nenhum número foi escolhido. Adicione um número no WhatsApp Manager e conecte de novo.',
    META_SIGNUP_NUMBER_AMBIGUOUS: 'A conta tem mais de um número e a Meta não informou qual foi escolhido. Conecte de novo ou use os dados do painel da Meta.',
    PHONE_NUMBER_ALREADY_CONNECTED: 'Este número já está conectado a outra instituição no Matrícula Mais.',
    META_SIGNUP_NOT_ALLOWED: 'Você não tem mais permissão para conectar canais nesta escola.',
    SUBSCRIPTION_READ_ONLY: 'A assinatura da escola está suspensa. Regularize em Configurações > Assinatura para conectar canais.',
    WHATSAPP_UNAVAILABLE: 'A Meta não respondeu agora. Tente de novo em alguns minutos.',
    WHATSAPP_TOKEN_INVALID: 'A Meta não liberou o acesso ao número com este login. Confira as permissões escolhidas e tente de novo.',
    TOO_MANY_ATTEMPTS: 'Muitas tentativas seguidas. Espere um minuto e tente de novo.',
    META_SIGNUP_PASS_EXPIRED: 'Este link de conexão venceu ou já foi usado. Feche esta janela e clique de novo em Conectar com a Meta, em Configurações > Canais.',
    EMBEDDED_SIGNUP_NOT_CONFIGURED: 'A conexão pela Meta depende da configuração da plataforma e ainda não foi ativada.',
    META_SIGNUP_PROOF_INVALID: 'Esta janela precisa ser aberta pelo botão Conectar com a Meta, em Configurações > Canais da escola.',
  }),
});

/** @param {string} [locale] */
export function metaSignupMessages(locale = 'pt-BR') {
  const key = /** @type {'pt-BR'} */ (locale in META_SIGNUP_MESSAGES ? locale : 'pt-BR');
  return {
    messages: /** @type {Record<string, string>} */ (META_SIGNUP_MESSAGES[key]),
    steps: /** @type {Record<string, string>} */ (META_SIGNUP_STEP_MESSAGES[key]),
    errors: /** @type {Record<string, string>} */ (META_SIGNUP_ERROR_MESSAGES[key]),
  };
}
